<div class="container mx-auto px-[12px] 2xl:px-0 py-[40px] md:py-[60px] lg:py-[80px]">

    <div class="relative overflow-hidden rounded-[16px] min-h-[220px] md:min-h-[260px] lg:min-h-[300px] flex items-center bg-cover bg-center bg-no-repeat"
         [style.backgroundImage]="imgAgenda ? 'url(' + imgAgenda + ')' : ''">

        <!-- Content -->
        <div class="relative z-10 px-[32px] md:px-[48px] lg:px-[64px] py-[40px] md:py-[50px] max-w-[600px]">

            <!-- Label -->
            <span class="block uppercase font-medium text-[12px] md:text-[13px] text-white/80 tracking-[0.2em] mb-[12px] md:mb-[16px]"
                  data-aos="fade-up" data-aos-duration="500" data-aos-delay="100">
                {{ texts?.schedule?.title }}
            </span>

            <!-- Title / Description -->
            <h2 class="font-bold text-white text-[26px] md:text-[32px] lg:text-[38px] xl:text-[42px] leading-[1.2] mb-[24px] md:mb-[32px]"
                data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
                {{ texts?.schedule?.description }}
            </h2>

            <!-- CTA Button -->
            <a href="javascript:void(0)"
               (click)="openCalendarDialog()"
               class="inline-block border-2 border-white text-white font-semibold text-[13px] md:text-[14px] tracking-widest uppercase px-[28px] md:px-[36px] py-[12px] md:py-[14px] rounded-full transition-all duration-300 hover:bg-white hover:text-Navy cursor-pointer"
               data-aos="fade-up" data-aos-duration="500" data-aos-delay="300">
                {{ texts?.schedule?.button }}
            </a>

        </div>
    </div>

</div>
